import React from 'react';
import './SidePanel.css';

const SidePanel = ({ activeItem, onNavClick, globalFunctionalities = [] }) => {
  const hasDashboardAccess = globalFunctionalities.includes('admin_dashboard') || globalFunctionalities.includes('manage_dashboard');

  return (
    <div className="side-panel">
      <div className="side-panel-top">
        <img src="https://teletailstest.s3.amazonaws.com/chat/1754688328693.png" alt="Teletails Logo" className="side-panel-logo" />
        <div className={`nav-item ${activeItem === 'Dashboard' ? 'active' : ''}`} onClick={() => onNavClick('Dashboard')}>
          <i className="fas fa-tachometer-alt nav-icon"></i>
          Dashboard
        </div>
        <div className={`nav-item ${activeItem === 'Incubations' ? 'active' : ''}`} onClick={() => onNavClick('Incubations')}>
          <i className="fas fa-lightbulb nav-icon"></i>
          Incubations
        </div>
        {/* Pet Duplicates removed */}
        {hasDashboardAccess && (
          <div className={`nav-item ${activeItem === 'Dashboard Access' ? 'active' : ''}`} onClick={() => onNavClick('Dashboard Access')}>
            <i className="fas fa-key nav-icon"></i>
            Dashboard Access
          </div>
        )}
        {/* External sections removed per request */}
      </div>
      
      <div className="side-panel-bottom">
        <div className="nav-item" onClick={() => onNavClick('Settings')}>
          <i className="fas fa-cog nav-icon"></i>
          Settings
        </div>
        <div className="nav-item" onClick={() => onNavClick('Sign Out')}>
          <i className="fas fa-sign-out-alt nav-icon"></i>
          Sign Out
        </div>
      </div>
    </div>
  );
};

export default SidePanel;